module.exports = "images/doc-program-print-2.34ba9207f6964ccefcce824ddec17487.png";